import { render } from "./AddArticleView.vue?vue&type=template&id=031a834c&scoped=true"
import script from "./AddArticleView.vue?vue&type=script&lang=js"
export * from "./AddArticleView.vue?vue&type=script&lang=js"

import "./AddArticleView.vue?vue&type=style&index=0&id=031a834c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-031a834c"]])

export default __exports__